module.exports = __webpack_public_path__ + "static/img/图层69.c83d981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层69.png
// module id = HwsU
// module chunks = 0